<template>
  <div v-loading="loadingList" class="cheat-scroll-wrapper">
    <ValidationObserver v-slot="{ handleSubmit }" ref="form">
      <form class="form" @submit.prevent="handleSubmit(handleCheatExam)">
        <div class="cheat-container">
          <table class="cheat-table">
            <thead>
              <tr>
                <th class="col-student-id">Mã Học Viên</th>
                <th class="col-student-name">Tên Học Viên</th>
                <th class="col-status">Vi phạm</th>
                <th class="col-skills">Kỹ năng vi phạm</th>
                <th class="col-description">Chi tiết lý do</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in tableData" :key="item.user_id">
                <td class="col-student-id">{{ item.user_id }}</td>
                <td class="col-student-name">{{ item.user_name }}</td>
                <td class="col-status">
                  <div
                    class="cheat-toggle"
                    :class="{ active: item.status }"
                    @click="toggleCheating(index)"
                  >
                    <i v-if="item.status" class="el-icon-close cheat-toggle-icon"></i>
                  </div>
                </td>
                <td class="col-skills">
                  <el-tooltip
                    v-if="item.skills && item.skills.length"
                    placement="top"
                    effect="dark"
                  >
                    <div slot="content" class="skill-tooltip-content">
                      {{ getReasonLabels(item.skills) }}
                    </div>
                    <span class="skill-select-wrapper">
                      <el-select
                        v-model="item.skills"
                        multiple
                        collapse-tags
                        placeholder="Chọn"
                        size="small"
                        class="skill-select"
                      >
                        <el-option
                          v-for="option in entranceTestSkillOptions"
                          :key="option.id"
                          :label="option.name"
                          :value="option.id"
                        />
                      </el-select>
                    </span>
                  </el-tooltip>
                  <ValidationProvider
                    v-else-if="item.status"
                    :vid="`violation_skill-${index + 1}`"
                    name="Kỹ năng vi phạm"
                    rules="required"
                    mode="eager"
                    v-slot="{ errors }"
                  >
                    <el-select
                      v-model="item.skills"
                      multiple
                      collapse-tags
                      placeholder="Chọn"
                      size="small"
                      class="skill-select skill-select--validated"
                    >
                      <el-option
                        v-for="option in entranceTestSkillOptions"
                        :key="option.id"
                        :label="option.name"
                        :value="option.id"
                      />
                    </el-select>
                    <div class="fv-plugins-message-container">
                      <div class="fv-help-block">{{ errors[0] }}</div>
                    </div>
                  </ValidationProvider>
                </td>
                <td class="col-description">
                  <el-input
                    v-if="item.status"
                    v-model="item.description"
                    placeholder="Nhập chi tiết lý do gian lận..."
                    size="mini"
                    class="cheat-input"
                  />
                </td>
              </tr>
            </tbody>
          </table>

          <div class="cheat-actions dialog-footer d-flex justify-content-end">
            <button
              type="button"
              class="mt-2 btn btn-secondary font-weight-bold mr-2"
              :disabled="submitting"
              @click="closeDialog"
            >
              Hủy bỏ
            </button>
            <button
              type="submit"
              class="mt-2 btn btn-primary font-weight-bold"
              :disabled="submitting || loadingList || !hasSelectedViolations"
            >
              <span v-if="!submitting">Xác nhận</span>
              <span v-else>Đang xử lý...</span>
            </button>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import {
  STUDENT_VIOLATION_LIST,
  STUDENT_VIOLATION,
} from '@/core/services/store/marking/marking.module';
import { SKILL_ARR } from '@/core/option/TaskManagementOption';

export default {
  name: 'ViolationRegulation',

  props: {
    markingExamShiftId: {
      type: Number,
      default: null,
    },
  },

  data() {
    return {
      tableData: [],
      loadingList: false,
      submitting: false,
      entranceTestSkillOptions: SKILL_ARR,
    };
  },

  mounted() {
    this.getListCheckStudentCheating();
  },

  computed: {
    hasSelectedViolations() {
      return this.tableData.some((item) => item.status);
    },
  },

  methods: {
    closeDialog() {
      this.$emit('closeDialog');
    },

    toggleCheating(index) {
      const item = this.tableData[index];
      item.status = !item.status;
      if (!item.status) {
        item.skills = null;
      }
    },

    async getListCheckStudentCheating() {
      this.loadingList = true;
      try {
        const res = await this.$store.dispatch(STUDENT_VIOLATION_LIST, {
          marking_exam_shift_id: this.markingExamShiftId,
        });
        if (!res.error) {
          this.tableData = (res.data ?? []).map((item) => ({
            ...item,
            status: item.skills?.length > 0
          }));
        }
      } finally {
        this.loadingList = false;
      }
    },

    getReasonLabels(ids) {
      return this.entranceTestSkillOptions
        .filter((option) => ids.includes(option.id))
        .map((option) => option.name)
        .join(', ');
    },

    buildViolationPayload() {
      return this.tableData
        .filter((item) => item.status)
        .map((item) => ({
          user_id: item.user_id,
          skills: item.skills ?? [],
          description: item.description,
          marking_exam_shift_id: item.marking_exam_shift_id,
          marking_exam_retake_id: item.id,
        }));
    },

    async handleCheatExam() {
      if (this.submitting) {
        return;
      }

      const payload = this.buildViolationPayload();
      if (!payload.length) {
        this.$message.warning('Vui lòng chọn ít nhất một học viên vi phạm');
        return;
      }

      this.submitting = true;
      try {
        const res = await this.$store.dispatch(STUDENT_VIOLATION, payload);
        if (!res.error) {
          this.$message.success('Đánh dấu học viên vi phạm quy chế thành công!');
          this.closeDialog();
        }
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>

<style scoped>
.cheat-scroll-wrapper {
  overflow-x: auto;
}

.cheat-container {
  min-width: 800px;
}

.cheat-table {
  width: 100%;
  border-collapse: collapse;
}

.cheat-table th,
.cheat-table td {
  padding: 16px 12px;
  text-align: left;
  vertical-align: middle;
}

.cheat-table th {
  background-color: #f5f7fa;
  font-weight: 600;
}

.col-student-id {
  white-space: nowrap;
  min-width: 110px;
}

.col-student-name {
  white-space: nowrap;
  min-width: 180px;
}

.col-status {
  min-width: 100px;
}

.col-skills {
  width: 240px;
}

.col-description {
  min-width: 200px;
}

.skill-tooltip-content {
  white-space: pre-wrap;
  max-width: 300px;
}

.skill-select-wrapper {
  display: inline-block;
  width: 100%;
}

.skill-select {
  width: 100%;
  border: 1px solid gray;
  border-radius: 5px;
}

.skill-select--validated {
  padding-left: 4px;
}

.cheat-toggle {
  width: 24px;
  height: 24px;
  background-color: #dcdfe6;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.cheat-toggle.active {
  background-color: #ac2626;
  color: white;
}

.cheat-toggle-icon {
  color: white !important;
}

.cheat-input {
  width: 100%;
  min-width: 200px;
}

.cheat-actions {
  margin-top: 20px;
  width: 100%;
}

::v-deep .el-input__inner {
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
  background-color: transparent;
  padding-left: 0;
}

::v-deep(.el-select .el-select__tags) {
  max-height: 22px;
  overflow: hidden;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
}

.el-select >>> .el-select__tags > span {
  margin-right: 4px;
}
</style>
